import { render, staticRenderFns } from "./SupplierRecognitionDialog.vue?vue&type=template&id=6a1ce940&scoped=true"
import script from "./SupplierRecognitionDialog.vue?vue&type=script&lang=js"
export * from "./SupplierRecognitionDialog.vue?vue&type=script&lang=js"
import style0 from "./SupplierRecognitionDialog.vue?vue&type=style&index=0&id=6a1ce940&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ce940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1ce940')) {
      api.createRecord('6a1ce940', component.options)
    } else {
      api.reload('6a1ce940', component.options)
    }
    module.hot.accept("./SupplierRecognitionDialog.vue?vue&type=template&id=6a1ce940&scoped=true", function () {
      api.rerender('6a1ce940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/components/SupplierRecognitionDialog.vue"
export default component.exports